<template>
  <div class="ss__appearance__setting__wrapper">
    <div
      class="ss__appearance__setting"
      :style="{'--SsAppearanceSettingCheckedIndex': checkedIndex}">
      <label
        :class="[
          'ss__appearance__radio__item',
          { 'ss__appearance__radio__item--checked': value === item.value }
        ]"
        v-for="item in options"
        :key="item.label">
        <i :class="item.icon"/><span>{{ item.label }}</span>
        <input
          type="radio"
          name="ssAppearanceSetting"
          :value="item.value"
          :checked="value === item.value"
          @change="$emit('change', item.value)"
        />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SsAppearanceSetting',

  props: {
    options: {
      type: Array
    },
    value: {
      type: Number
    }
  },

  computed: {
    checkedIndex () {
      return this.options.findIndex(item => this.value === item.value)
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__appearance__setting {
  width: calc(266px + 8px);
  height: calc(62px + 8px);
  padding: 4px;
  box-sizing: border-box;
  border-radius: 12px;
  background: var(--B2-t-overlay);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
  &:after {
    content: '';
    display: block;
    width: 78px;
    height: 62px;
    border-radius: 8px;
    background: var(--B0-t-overlay);
    box-shadow: var(--shadow-level-1);
    position: absolute;
    left: 4px;
    z-index: 0;
    transform: translateX(calc(var(--SsAppearanceSettingCheckedIndex) * (100% + 16px)));
    transition: transform var(--a-dur-short) var(--a-func-short);
  }
}
.ss__appearance__radio__item {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 4px;
  width: 78px;
  height: 62px;
  border-radius: 12px;
  transition: .2s;
  position: relative;
  z-index: 1;

  input {
    display: none;
  }
  [class^="ssCommunityIcon__"], [class*=" ssCommunityIcon__"] {
    font-size: 24px;
  }
}
</style>
